import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type TableFilterIdentifier = "animalsList" | "groupsList" | "fieldsList" | "tagsList";

interface Filters {
  fieldId: string;
  groupId: string;
  tagIds: string[];
  sex: string;
  breed: string;
  pregnancyStatus: string;
  dateOfBirth: {
    from: string | undefined;
    to: string | undefined;
  };
  dateOnFarm: {
    from: string | undefined;
    to: string | undefined;
  };
}

const INITIAL_FILTERS: Filters = {
  fieldId: "",
  groupId: "",
  tagIds: [],
  sex: "",
  breed: "",
  pregnancyStatus: "",
  dateOfBirth: {
    from: undefined,
    to: undefined,
  },
  dateOnFarm: {
    from: undefined,
    to: undefined,
  },
};

interface InitialFilterState {
  filters: Filters;
  showFilters: boolean;
}

const initialFilterState: InitialFilterState = {
  filters: INITIAL_FILTERS,
  showFilters: false,
};

type State = Record<TableFilterIdentifier, InitialFilterState>;

const initialState: State = {
  animalsList: initialFilterState,
  tagsList: initialFilterState,
  fieldsList: initialFilterState,
  groupsList: initialFilterState,
};

type FiltersPayload = { tableIdentifier: TableFilterIdentifier; filters: Filters };

export const animalFiltersSlice = createSlice({
  name: "animalFilters",
  initialState,
  reducers: {
    updateFilters: (state, action: PayloadAction<FiltersPayload>) => {
      const { tableIdentifier } = action.payload;
      const updatedFilters = action.payload.filters;
      state[tableIdentifier].filters = updatedFilters;
    },
    toggleFilter: (state, action: PayloadAction<{ tableIdentifier: TableFilterIdentifier; showFilters: boolean }>) => {
      const { tableIdentifier } = action.payload;
      state[tableIdentifier].showFilters = !action.payload.showFilters;
    },
    resetFilters: (state, action: PayloadAction<TableFilterIdentifier>) => {
      state[action.payload].filters = INITIAL_FILTERS;
    },
  },
});

export const { updateFilters, toggleFilter, resetFilters } = animalFiltersSlice.actions;
export const animalFiltersReducer = animalFiltersSlice.reducer;
